// This file was auto-generated by Fern from our API Definition.
export var PendingInputAdmissionResponse;
(function (PendingInputAdmissionResponse) {
    PendingInputAdmissionResponse.Action = {
        Execute: "execute",
        Pending: "pending",
    };
})(PendingInputAdmissionResponse || (PendingInputAdmissionResponse = {}));
